"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.erc20SignatureInfo = exports.hydrate = exports.preload = exports.fetchERC20Tokens = exports.modes = void 0;
// handle erc20 feature others than send.
var ethereumjs_abi_1 = __importDefault(require("ethereumjs-abi"));
var invariant_1 = __importDefault(require("invariant"));
var eip55_1 = __importDefault(require("eip55"));
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var transaction_1 = require("../transaction");
var account_1 = require("../../../account");
var currencies_1 = require("../../../currencies");
var logic_1 = require("../../../compound/logic");
var errors_2 = require("../../../errors");
var env_1 = require("../../../env");
var logs_1 = require("@ledgerhq/logs");
var network_1 = __importDefault(require("../../../network"));
var cache_1 = require("../../../cache");
var erc20_1 = require("@ledgerhq/hw-app-eth/erc20");
var infinite = new bignumber_js_1.BigNumber(2).pow(256).minus(1);
function contractField(transaction, currency) {
    var recipientToken = (0, cryptoassets_1.findTokenByAddressInCurrency)(transaction.recipient, currency.id);
    var maybeCompoundToken = (0, currencies_1.findTokenById)((recipientToken === null || recipientToken === void 0 ? void 0 : recipientToken.compoundFor) || "");
    return {
        type: "text",
        label: maybeCompoundToken ? "Contract" : "Address",
        value: maybeCompoundToken
            ? "Compound " + maybeCompoundToken.ticker
            : transaction.recipient
    };
}
/**
 * "erc20.approve" allows a "spender" (e.g. contract address) to consume some erc20 tokens.
 * transaction params:
 * - transaction.recipient address of the spender
 * - transaction.amount in the token unit to allow
 * - transaction.useAllAmount intend to allow infinite amount (setting a very high value)
 */
var erc20approve = {
    fillTransactionStatus: function (a, t, result) {
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        var _a = (subAccount && (0, logic_1.getAccountCapabilities)(subAccount)) || {}, status = _a.status, enabledAmount = _a.enabledAmount;
        if (!t.useAllAmount) {
            if (t.amount.eq(0)) {
                result.errors.amount = new errors_1.AmountRequired();
            }
            else if (subAccount &&
                status &&
                enabledAmount &&
                ["EARNING", "SUPPLYING"].includes(status) &&
                t.amount.lt(enabledAmount)) {
                var unit = (0, account_1.getAccountUnit)(subAccount);
                // if account curently supplied we can't lower the initial amount enabled just augment it
                result.errors.amount = new errors_2.CompoundLowerAllowanceOfActiveAccountError(undefined, {
                    minimumAmount: (0, currencies_1.formatCurrencyUnit)(unit, enabledAmount, {
                        disableRounding: true,
                        useGrouping: false,
                        showCode: true
                    })
                });
            }
        }
        result.amount = t.amount;
    },
    fillTransactionData: function (a, t, tx) {
        var subAccount = (0, transaction_1.inferTokenAccount)(a, t);
        (0, invariant_1["default"])(subAccount, "sub account missing");
        // FIXME: make sure it doesn't break
        if (!subAccount)
            throw new Error("sub account missing");
        var recipient = eip55_1["default"].encode(t.recipient);
        var amount;
        if (t.useAllAmount) {
            amount = infinite;
        }
        else {
            (0, invariant_1["default"])(t.amount, "amount missing");
            amount = new bignumber_js_1.BigNumber(t.amount);
        }
        var data = ethereumjs_abi_1["default"].simpleEncode("approve(address,uint256)", recipient, amount.toString(10));
        tx.data = "0x" + data.toString("hex");
        tx.to = subAccount.token.contractAddress;
        tx.value = "0x00";
        return {
            erc20contracts: [recipient]
        };
    },
    fillDeviceTransactionConfig: function (_a, fields) {
        var transaction = _a.transaction, account = _a.account, parentAccount = _a.parentAccount;
        fields.push({
            type: "text",
            label: "Type",
            value: "Approve"
        });
        if (transaction.useAllAmount) {
            fields.push({
                type: "text",
                label: "Amount",
                value: "Unlimited " + (0, account_1.getAccountCurrency)(account).ticker
            });
        }
        else {
            // TODO amount should be just text in future
            fields.push({
                type: "amount",
                label: "Amount"
            });
        }
        fields.push(contractField(transaction, (0, account_1.getMainAccount)(account, parentAccount).currency));
    },
    fillOptimisticOperation: function (_account, _transaction, operation) {
        operation.type = "FEES";
    },
    getResolutionConfig: function () { return ({ erc20: true, externalPlugins: true }); }
};
exports.modes = {
    "erc20.approve": erc20approve
};
exports.fetchERC20Tokens = (0, cache_1.makeLRUCache)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var tokens, data, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, (0, network_1["default"])({
                        url: "".concat((0, env_1.getEnv)("DYNAMIC_CAL_BASE_URL"), "/erc20.json")
                    })];
            case 1:
                data = (_a.sent()).data;
                if (!data || !Array.isArray(data)) {
                    throw new Error("ERC20.json file was malformed");
                }
                tokens = data;
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                (0, logs_1.log)("preload-erc20", "failed to preload erc20 ".concat(e_1.toString()));
                tokens = [];
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, tokens];
        }
    });
}); }, function () { return "erc20-tokens"; }, {
    ttl: 6 * 60 * 60 * 1000
});
function preload(currency) {
    return __awaiter(this, void 0, void 0, function () {
        var tokens, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (currency.id !== "ethereum") {
                        return [2 /*return*/, Promise.resolve(null)];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, exports.fetchERC20Tokens)()];
                case 2:
                    tokens = _a.sent();
                    (0, currencies_1.addTokens)(tokens.map(cryptoassets_1.convertERC20));
                    return [2 /*return*/, tokens];
                case 3:
                    e_2 = _a.sent();
                    (0, logs_1.log)("Ethereum Family", "Error while adding tokens in preload", e_2);
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.preload = preload;
function hydrate(value, currency) {
    if (currency.id !== "ethereum" || !value)
        return;
    (0, currencies_1.addTokens)(value.map(cryptoassets_1.convertERC20));
    (0, logs_1.log)("ethereum/preload", "hydrate " + value.length + " tokens");
}
exports.hydrate = hydrate;
exports.erc20SignatureInfo = (0, cache_1.makeLRUCache)(function (loadConfig) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, (0, erc20_1.findERC20SignaturesInfo)(loadConfig)];
}); }); }, function () { return "erc20-signatures"; });
//# sourceMappingURL=erc20.js.map